import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Box, Typography, CircularProgress, Alert } from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const UserVerificationList = ({ userId }) => {
    const adminId = userId;
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch users with 'under progress' status
        axios.get(`${API_URL}/user/verification/under-progress/`)
            .then(response => {
                setUsers(response.data);
                setLoading(false);
            })
            .catch(err => {
                setError("Error fetching users.");
                setLoading(false);
            });
    }, []);

    const handleStatusUpdate = (userId, status) => {
        setLoading(true);
        
        // Check if adminId is available
        if (!adminId) {
            setError("Admin ID is required.");
            setLoading(false);
            return;
        }

        // Send POST request to update the verification status
        axios.post(`${API_URL}/user/verification/update-status/`, {
            user_id: userId,
            admin_id: adminId,  // Sending adminId in the request
            status: status       // Either "approved" or "pending"
        })
        .then(response => {
            // After successful update, update the local state
            setUsers(users.map(user =>
                user.id === userId ? { ...user, status: response.data.message } : user
            ));
            setLoading(false);
        })
        .catch(err => {
            // Handle any errors
            setError("Error updating verification status.");
            setLoading(false);
        });
    };

    return (
        <Box sx={{ padding: 3, backgroundColor: '#f5f5f5' }}>
            <Typography variant="h4" component="h1" sx={{ marginBottom: 3 }}>User Verification</Typography>

            {loading && <CircularProgress />}

            {error && <Alert severity="error">{error}</Alert>}

            {!loading && !error && users.length === 0 && (
                <Typography>No users are currently under verification.</Typography>
            )}

            {!loading && !error && users.length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {users.map(user => (
                        <Box
                            key={user.id}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 2,
                                padding: 2,
                                backgroundColor: '#fff',
                                borderRadius: 1,
                                boxShadow: 1
                            }}
                        >
                            <Link to={`/user-profile-admin-view/${user.id}`} style={{ textDecoration: "none" }}>
                                <Typography>{user.name} - Status: {user.status}</Typography>
                            </Link>
                            <Box>
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: '#4caf50', marginRight: 2 }}
                                    onClick={() => handleStatusUpdate(user.id, 'approved')}
                                >
                                    Approve
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ backgroundColor: '#f44336' }}
                                    onClick={() => handleStatusUpdate(user.id, 'pending')}
                                >
                                    Reject
                                </Button>
                            </Box>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default UserVerificationList;
